import { useTheme } from '@mui/material/styles';
import { createLink } from '@tanstack/react-router';
import type { ComponentProps } from 'react';

import wellhubUscMobileLogo from 'assets/images/wellhub-usc-logo-mobile.svg';
import wellhubUscDesktopLogo from 'assets/images/wellhub-USC-logo-desktop.svg';
import wellhubLogo from 'assets/images/wellhub-logo-vibin.svg';

import { useLocalization } from 'providers/LocalizationProvider';

import { CoBrandPicture, LogoButton, Image } from './WellhubLogo.style';

const CreatedLinkComponent = createLink(LogoButton);

function LogoLink(props: ComponentProps<typeof CreatedLinkComponent>) {
  return <CreatedLinkComponent preload="intent" {...props} />;
}

export type WellhubLogoVariant = 'wellhub' | 'wellhub-usc';

export type WellhubLogoProps = ComponentProps<typeof CreatedLinkComponent> & {
  /** `wellhub` renders the plain Wellhub logo; `wellhub-usc` renders the co-branded lockup. */
  variant?: WellhubLogoVariant;
  label?: string;
  onClick?: () => void;
};

function WellhubImage() {
  return <img src={wellhubLogo} alt="wellhub-logo" width={132} height={24} />;
}

function CoBrandImage() {
  const { t } = useLocalization();
  const theme = useTheme();

  return (
    <CoBrandPicture>
      <source
        media={`(min-width:${theme.breakpoints.values.md}px)`}
        srcSet={wellhubUscDesktopLogo}
      />

      <Image
        src={wellhubUscMobileLogo}
        alt={t('usc_forwarding_modal.logo_alt')}
      />
    </CoBrandPicture>
  );
}

export function WellhubLogo({
  variant = 'wellhub',
  label,
  ...linkProps
}: WellhubLogoProps) {
  return (
    <LogoLink {...linkProps} aria-label={label}>
      {variant === 'wellhub-usc' ? <CoBrandImage /> : <WellhubImage />}
    </LogoLink>
  );
}
